export interface Office {
    officeVersion: string;
    url32: string;
    url64: string;
}

export interface Package {
    packageVersion: string;
    offices: Office[];
}

export const initData: Package[] = [
    {
        packageVersion: "2.0.0",
        offices: [
            {
                officeVersion: "2010",
                url32: "http://url32",
                url64: "http://url64",
            },
            {
                officeVersion: "2013",
                url32: "http://url32",
                url64: "http://url64",
            },
            {
                officeVersion: "2016",
                url32: "http://url32",
                url64: "http://url64",
            },
            {
                officeVersion: "2019",
                url32: "http://url32",
                url64: "http://url64",
            },
            {
                officeVersion: "365",
                url32: "http://url32",
                url64: "http://url64",
            },
        ],
    },
    {
        packageVersion: "1.9.0",
        offices: [
            {
                officeVersion: "2016",
                url32: "http://url32",
                url64: "http://url64",
            },
            {
                officeVersion: "2019",
                url32: "http://url32",
                url64: "http://url64",
            },
            {
                officeVersion: "365",
                url32: "http://url32",
                url64: "http://url64",
            },
        ],
    },
    {
        packageVersion: "1.8.0",
        offices: [
            {
                officeVersion: "2013",
                url32: "http://url32",
                url64: "http://url64",
            },
            {
                officeVersion: "2016",
                url32: "http://url32",
                url64: "http://url64",
            },
            {
                officeVersion: "2019",
                url32: "http://url32",
                url64: "http://url64",
            },
            {
                officeVersion: "365",
                url32: "http://url32",
                url64: "http://url64",
            },
        ],
    },
];